import { put, call, takeEvery } from "redux-saga/effects";
import athenaClient from "lib/axios/clients";
import buildRequestUrl from "lib/requests/requestUtils";
import _ from "lodash";
import { addCategoriesList, addLinesList, addProductsList } from "./slices";
import addCategoriesListAsyncAction, {
  addLinesListAsyncAction,
  addProductsListAsyncAction,
} from "./actions";

function* addCategoriesListAsync(action) {
  const url = buildRequestUrl(action.payload, "categories");

  const config = {
    method: "GET",
    url,
  };

  const response = yield call(athenaClient, config);

  yield put(addCategoriesList(_.keyBy(response.data, "id")));
}

export default function* watchAddCategoriesListAsync() {
  yield takeEvery(addCategoriesListAsyncAction, addCategoriesListAsync);
}

function* addLinesListAsync(action) {
  const url = buildRequestUrl(action.payload, "lines");

  const config = {
    method: "GET",
    url,
  };

  const response = yield call(athenaClient, config);

  yield put(addLinesList(_.keyBy(response.data, "id")));
}

export function* watchAddLinesListAsync() {
  yield takeEvery(addLinesListAsyncAction, addLinesListAsync);
}

function* addProductsListAsync(action) {
  const url = buildRequestUrl(action.payload, "products");

  const config = {
    method: "GET",
    url,
  };

  const response = yield call(athenaClient, config);

  yield put(addProductsList(_.keyBy(response.data, "id")));
}

export function* watchAddProductsListAsync() {
  yield takeEvery(addProductsListAsyncAction, addProductsListAsync);
}
